import React, { useState, useEffect } from "react";
import { Form, Col, Row, Button, Select, Collapse } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const PaymentSetTableFilter = (props) => {
  const [form] = Form.useForm();

  const [paymentSelect, setPaymentSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onPaymentSetSearch = (value) => {
    if (value.length >= 2) {
      setPaymentSelect({ data: [], loading: true });

      RequestHandler.get(
        `/PaymentSet?$select=id,name&$filter=${odata.contains("name", value)}`
      ).then((res) => {
        setPaymentSelect({
          data: [{ id: `_${value}`, name: `'${value}' içerenleri ara` }].concat(
            res.value
          ),
          loading: false,
        });
      });
    } else {
      setPaymentSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.paymentSetId) {
        if (values.paymentSetId.startsWith("_")) {
          const searchValue = values.paymentSetId.slice(1);
          conditions.push(odata.contains("name", searchValue));
        } else {
          conditions.push(`id eq ${values.paymentSetId}`);
        }
      }

      if (values.isDefaultForConstantPaymentLink === 0) {
        conditions.push(`isDefaultForConstantPaymentLink eq true`);
      }

      if (values.isDefaultForConstantPaymentLink === 1) {
        conditions.push(`isDefaultForConstantPaymentLink eq false`);
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }
      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="paymentSetId" label="Ödeme Seti :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onPaymentSetSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={paymentSelect.loading}
                    >
                      {paymentSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          style={
                            item.id.startsWith("_") ? { color: "gray" } : {}
                          }
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="isDefaultForConstantPaymentLink"
                    label="Varsayılan Ödeme Seti :"
                  >
                    <Select allowClear placeholder="Tümü">
                      {[
                        { id: 0, name: "Evet" },
                        { id: 1, name: "Hayır" },
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default PaymentSetTableFilter;
